this["cfe"] = this["cfe"] || {};
this["cfe"]["components"] = this["cfe"]["components"] || {};
this["cfe"]["components"]["Navbar"] = this["cfe"]["components"]["Navbar"] || {};
this["cfe"]["components"]["Navbar"]["index"] = this["cfe"]["components"]["Navbar"]["index"] || {};
this["cfe"]["components"]["Navbar"]["index"]["callbacks"] = {
  componentDidMount: function () {
    const self = this;
    dropdown.parent = jQuery('.dropdown'),
    dropdown.menu   = jQuery('.dropdown .dropdown-menu.level-1'),
    dropdown.button = jQuery('.dropdown-toggle'),
    dropdown.button.unbind('click');
    dropdown.trigger(dropdown.button);
  }
}
;